export function returnArrowsState(props, { leftArrow }) {
  const {
    listContainerWidth,
    buttonListWidth,
    sidePanelOpen,
  } = props;
  if (listContainerWidth < buttonListWidth && !leftArrow) {
    return {
      leftArrow: false,
      rightArrow: true,
      sidePanelOpen,
    };
  }
  if (listContainerWidth >= buttonListWidth) {
    return {
      leftArrow: false,
      rightArrow: false,
      sidePanelOpen,
    };
  }
  return null;
}
